import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox } from '@material-ui/core';

const CheckboxField = ({ className, labelClassName, instanceId, checked, onChange, name, color, label, disabled }) => {
  const [isChecked, setChecked] = React.useState(checked);

  const handleChange = checkedStatus => {
    onChange(checkedStatus);
    setChecked(checkedStatus);
  };

  React.useEffect(() => {
    setChecked(checked);
  }, [checked]);

  return (
    <div className={className}>
      <FormControlLabel
        id={instanceId}
        control={
          <Checkbox
            checked={isChecked}
            onChange={event => {
              handleChange(event.target.checked);
            }}
            value={name}
            color={color}
            disabled={disabled}
          />
        }
        label={label}
        classes={{
          label: labelClassName,
        }}
      />
    </div>
  );
};

CheckboxField.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  color: PropTypes.string,
  instanceId: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
};

CheckboxField.defaultProps = {
  color: 'secondary',
  label: '',
};

export default CheckboxField;
